import AdtInfoImportLogTable from "./adtInfoImportLogTable.container";

export default AdtInfoImportLogTable;
